// ----------------- ETCH RELATED PROVIDERS -----------------
export const FETCH_RELATED_PROVIDERS_LOADING =
	'FETCH_RELATED_PROVIDERS_LOADING';
export const FETCH_RELATED_PROVIDERS_SUCCESS =
	'FETCH_RELATED_PROVIDERS_SUCCESS';
export const FETCH_RELATED_PROVIDERS_ERROR = 'FETCH_RELATED_PROVIDERS_ERROR';

// ----------------- REMOVE RELATED PROVIDER -----------------
export const REMOVE_PROVIDER_LOADING = 'REMOVE_PROVIDER_LOADING';
export const REMOVE_PROVIDER_SUCCESS = 'REMOVE_PROVIDER_SUCCESS';
export const REMOVE_PROVIDER_ERROR = 'REMOVE_PROVIDER_ERROR';
